import SectionRecord from "models/view-models/section-record";
import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface SharedPageSectionResourcePathParams {
    sectionId: number;
    pageGuid: string;
}

interface SharedPageSectionBasePathParams {
    pageGuid: string;
}

interface SharedPageSectionQueryParams {
    /**
     * Return all sections with a matching parentId and recursively return their subsections
     */
    parentId?: number;
    recipient?: string;
}

interface SharedPageSectionGetQueryParams {
    /**
     * Query parameters for getting a shared page section
     */
    recipient?: string;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = "public/pages/:pageGuid/sections";
const resourceEndpoint = `${baseEndpoint}/:sectionId`;
const resourceType = SectionRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const SharedPageSectionService = {
    key: "sharedPageSections",

    get: ServiceFactory.get<
        SectionRecord,
        SharedPageSectionResourcePathParams,
        SharedPageSectionGetQueryParams
    >(resourceType, resourceEndpoint),

    list: ServiceFactory.nestedList<
        SectionRecord,
        SharedPageSectionBasePathParams,
        SharedPageSectionQueryParams
    >(resourceType, baseEndpoint),

    useGet: ServiceHookFactory.useGet<
        SectionRecord,
        SharedPageSectionResourcePathParams,
        SharedPageSectionGetQueryParams
    >(resourceType, resourceEndpoint),

    useList: ServiceHookFactory.useNestedList<
        SectionRecord,
        SharedPageSectionBasePathParams,
        SharedPageSectionQueryParams
    >(resourceType, baseEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default SharedPageSectionService;

// #endregion Exports
